import React from 'react'
import './universities.css'
import Header from '../components/Header/Header'
import Footer from '../components/Header/Footer'
import UniversitiesA from '../components/Universitiescomp/UniversitiesA'

const Universities = () => {
  return (
    <div className='main'>

<Header/>
<UniversitiesA/>
<Footer/>


    </div>
  )
}

export default Universities